export const products = [
  {
    id: 1,
    category: "traditional",
    name: {
      de: "Burek mit Fleisch",
      en: "Meat Burek",
      bs: "Burek",
    },
    description: {
      de: "Traditioneller bosnischer Burek mit saftigem Hackfleisch und knusprigem Teig",
      en: "Traditional Bosnian burek with juicy minced meat and crispy dough",
      bs: "Tradicionalni bosanski burek sa sočnim mljevenim mesom i hrskavim tijestom",
    },
    price: 4.0,
    image: `${process.env.PUBLIC_URL}/burek.png`,
    popular: true,
  },
  {
    id: 2,
    category: "traditional",
    name: {
      de: "Burek mit Käse",
      en: "Cheese Pie",
      bs: "Sirnica",
    },
    description: {
      de: "Köstliche Käsepastete mit cremigem Käse und dünnen Teigschichten",
      en: "Delicious cheese pie with creamy cheese and thin layers of dough",
      bs: "Ukusna pita sa kremastim sirom i tankim slojevima tijesta",
    },
    price: 4.0,
    image: `${process.env.PUBLIC_URL}/sirnica.png`,
    popular: true,
  },
  {
    id: 3,
    category: "traditional",
    name: {
      de: "Burek mit Kartoffeln",
      en: "Potato Pie",
      bs: "Krompiruša",
    },
    description: {
      de: "Leckere gefüllte Teigtasche mit würziger Kartoffelfüllung",
      en: "Delicious filled pastry with savory potato filling",
      bs: "Ukusna punjena pita sa začinjenim krompirom",
    },
    price: 4.0,
    image: `${process.env.PUBLIC_URL}/krompirusa.png`,
    popular: false,
  },
  {
    id: 4,
    category: "traditional",
    name: {
      de: "Burek mit Zucchini",
      en: "Zucchini Pie",
      bs: "Tikvenjača",
    },
    description: {
      de: "Frische Hörnchen mit Zucchini, perfekt zum Frühstück oder als Snack",
      en: "Fresh pastry with zucchini, perfect for breakfast or as a snack",
      bs: "Svježa pita sa tikvicama, savršena za doručak ili užinu",
    },
    price: 4.0,
    image: `${process.env.PUBLIC_URL}/tikvica.png`,
    popular: false,
  },

  {
    id: 4.5,
    category: "traditional",
    name: {
      de: "Burek mit Spinat/Käse",
      en: "Spinat Pie",
      bs: "Zeljanica",
    },
    description: {
      de: "Frische Hörnchen mit Spinat/Käse, perfekt zum Frühstück oder als Snack",
      en: "Fresh pastry with spinat and cheese, perfect for breakfast or as a snack",
      bs: "Zeljanica, savršena za doručak ili užinu",
    },
    price: 4.0,
    image: `${process.env.PUBLIC_URL}/zeljanica.png`,
    popular: false,
  },
  {
    id: 5,
    category: "traditional",
    name: {
      de: "Maslanica",
      en: "Maslanica",
      bs: "Maslanica",
    },
    description: {
      de: "Leckeres traditionelles bosnisches Gebäck aus Blätterteig mit Buttergeschmack",
      en: "Delicious traditional Bosnian pastry made with puff pastry and buttery flavor",
      bs: "Ukusan tradicionalni bosanski kolač od lisnatog tijesta sa maslacem",
    },
    price: 10.0,
    image: `${process.env.PUBLIC_URL}/maslanica.png`,
    popular: false,
  },

  // HOT MEALS
  {
    id: 6,
    category: "hotMeals",
    name: {
      de: "Gulasch",
      en: "Goulash",
      bs: "Gulaš",
    },
    description: {
      de: "Herzhafter Gulasch nach Hausrezept, langsam geschmort mit zartem Fleisch",
      en: "Hearty homemade goulash, slow-cooked with tender meat",
      bs: "Krepki domaći gulaš, polako kuhan sa mekanim mesom",
    },
    price: 10.0,
    image: `${process.env.PUBLIC_URL}/gulasch.png`,
    popular: false,
  },
  {
    id: 7,
    category: "hotMeals",
    name: {
      de: "Bohnensuppe",
      en: "Bean Soup",
      bs: "Čorba od graha",
    },
    description: {
      de: "Wärmende Bohnensuppe nach traditioneller Art, ideal für kalte Tage",
      en: "Warming traditional bean soup, perfect for colder days",
      bs: "Topla tradicionalna čorba od graha, savršena za hladne dane",
    },
    price: 8.0,
    image: `${process.env.PUBLIC_URL}/bohnensuppe.png`,
    popular: false,
  },
  {
    id: 8,
    category: "hotMeals",
    name: {
      de: "Hühnersuppe",
      en: "Chicken Soup",
      bs: "Pileća supa",
    },
    description: {
      de: "Klassische Hühnersuppe mit Gemüse, leicht und aromatisch",
      en: "Classic chicken soup with vegetables, light and flavorful",
      bs: "Klasična pileća supa s povrćem, lagana i aromatična",
    },
    price: 6.0,
    image: `${process.env.PUBLIC_URL}/huhnersuppe.png`,
    popular: false,
  },
  {
    id: 9,
    category: "hotMeals",
    name: {
      de: "Ćevapi (10 Stück)",
      en: "Ćevapi (10 pieces)",
      bs: "Ćevapi (10 komada)",
    },
    description: {
      de: "10 saftige Ćevapi vom Grill, serviert mit Lepina und Beilagen",
      en: "10 juicy grilled ćevapi, served with flatbread and sides",
      bs: "10 sočnih ćevapa sa roštilja, posluženi sa lepinjom i prilozima",
    },
    price: 12.5,
    image: `${process.env.PUBLIC_URL}/cevapi.png`,
    popular: true,
  },
  {
    id: 10,
    category: "hotMeals",
    name: {
      de: "Ćevapi (5 Stück)",
      en: "Ćevapi (5 pieces)",
      bs: "Ćevapi (5 komada)",
    },
    description: {
      de: "5 saftige Ćevapi vom Grill, serviert mit Lepina und Beilagen",
      en: "5 juicy grilled ćevapi, served with flatbread and sides",
      bs: "5 sočnih ćevapa sa roštilja, posluženi sa lepinjom i prilozima",
    },
    price: 8.5,
    image: `${process.env.PUBLIC_URL}/cevapi.png`,
    popular: true,
  },

  // DESSERTS
  {
    id: 11,
    category: "desserts",
    name: {
      de: "Tiramisu",
      en: "Tiramisu",
      bs: "Tiramisu",
    },
    description: {
      de: "Cremiges Tiramisu-Dessert mit Mascarpone und Kaffee",
      en: "Creamy tiramisu dessert with mascarpone and coffee",
      bs: "Kremasti tiramisu desert sa maskarpone sirom i kafom",
    },
    price: 3.0,
    image: `${process.env.PUBLIC_URL}/tiramisu.png`,
    popular: false,
  },
  {
    id: 12,
    category: "desserts",
    name: {
      de: "Verschiedene Tortensorten",
      en: "Assorted Cake Slices",
      bs: "Razne vrste torti",
    },
    description: {
      de: "Verschiedene hausgemachte Tortensorten zur Auswahl",
      en: "Assorted homemade cake slices to choose from",
      bs: "Različite vrste domaćih torti na izbor",
    },
    price: 3.5,
    image: `${process.env.PUBLIC_URL}/torten.png`,
    popular: false,
  },
  {
    id: 13,
    category: "desserts",
    name: {
      de: "Hurmasice",
      en: "Hurmasice",
      bs: "Hurmašice",
    },
    description: {
      de: "Traditionelles sirupgetränktes Gebäck aus dem Balkan",
      en: "Traditional syrup-soaked Balkan pastry",
      bs: "Tradicionalni balkanski kolač u šećernom sirupu",
    },
    price: 2.5,
    image: `${process.env.PUBLIC_URL}/hurmasice.png`,
    popular: false,
  },
  {
    id: 14,
    category: "desserts",
    name: {
      de: "Čupavac",
      en: "Čupavac",
      bs: "Čupavac",
    },
    description: {
      de: "Lockerer Biskuitkuchen mit Schokolade und Kokosraspeln",
      en: "Soft sponge cake with chocolate and shredded coconut",
      bs: "Mekani biskvit kolač sa čokoladom i kokosom",
    },
    price: 3.0,
    image: `${process.env.PUBLIC_URL}/cupavac.png`,
    popular: false,
  },

  // DRINKS
  {
    id: 15,
    category: "drinks",
    name: {
      de: "Kaffee klein",
      en: "Small Coffee",
      bs: "Mala kafa",
    },
    description: {
      de: "Kleiner frisch gebrühter Kaffee",
      en: "Small freshly brewed coffee",
      bs: "Mala svježe kuhana kafa",
    },
    price: 2.5,
    image: `${process.env.PUBLIC_URL}/kaffee-klein.png`,
    popular: false,
  },
  {
    id: 16,
    category: "drinks",
    name: {
      de: "Kaffee groß",
      en: "Large Coffee",
      bs: "Velika kafa",
    },
    description: {
      de: "Große Tasse frisch gebrühten Kaffees",
      en: "Large cup of freshly brewed coffee",
      bs: "Velika šolja svježe kuhane kafe",
    },
    price: 3.0,
    image: `${process.env.PUBLIC_URL}/kaffee-gross.png`,
    popular: false,
  },
  {
    id: 17,
    category: "drinks",
    name: {
      de: "Cappuccino",
      en: "Cappuccino",
      bs: "Kapučino",
    },
    description: {
      de: "Cremiger Cappuccino mit Milchschaum",
      en: "Creamy cappuccino with milk foam",
      bs: "Kremasti kapučino sa mliječnom pjenom",
    },
    price: 3.0,
    image: `${process.env.PUBLIC_URL}/cappuccino.png`,
    popular: false,
  },
  {
    id: 18,
    category: "drinks",
    name: {
      de: "Latte Macchiato",
      en: "Latte Macchiato",
      bs: "Latte macchiato",
    },
    description: {
      de: "Sanfter Latte Macchiato mit Milch und Espresso",
      en: "Smooth latte macchiato with milk and espresso",
      bs: "Njezni latte macchiato sa mlijekom i espresom",
    },
    price: 3.5,
    image: `${process.env.PUBLIC_URL}/latte-macchiato.png`,
    popular: false,
  },
  {
    id: 19,
    category: "drinks",
    name: {
      de: "Espresso",
      en: "Espresso",
      bs: "Espreso",
    },
    description: {
      de: "Starker, kurzer Espresso",
      en: "Strong, short espresso",
      bs: "Jak, kratki espreso",
    },
    price: 2.0,
    image: `${process.env.PUBLIC_URL}/espresso.png`,
    popular: false,
  },
  {
    id: 20,
    category: "drinks",
    name: {
      de: "Espresso Macchiato",
      en: "Espresso Macchiato",
      bs: "Espreso macchiato",
    },
    description: {
      de: "Espresso mit einem Schuss Milchschaum",
      en: "Espresso with a dash of milk foam",
      bs: "Espreso sa malo mliječne pjene",
    },
    price: 2.5,
    image: `${process.env.PUBLIC_URL}/espresso-macchiato.png`,
    popular: false,
  },
  {
    id: 21,
    category: "drinks",
    name: {
      de: "Tee (verschiedene Sorten)",
      en: "Tea (various kinds)",
      bs: "Čaj (različite vrste)",
    },
    description: {
      de: "Auswahl an verschiedenen Teesorten",
      en: "Selection of different teas",
      bs: "Različite vrste čajeva na izbor",
    },
    price: 2.5,
    image: `${process.env.PUBLIC_URL}/tee.png`,
    popular: false,
  },
];
